export const env = {
    REACT_APP_API_URL: 'https://uber-api-uat.myacolad.com/',
    SENTRY_DSN: 'https://6010b7391fc94285a9642701482a6529@sentry.io/4572708',
    SENTRY_ENVIRONMENT: 'local',
    AEM_URL: 'https://admin-author-alb-one-prod-1-euw1.wrd-aws.com/sites.html/content/',
    AT_RISK_THRESHOLD: 3,
}
